import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'virtual-pcons-dialog',
  templateUrl: './virtual-pcons-dialog.component.html',
  styleUrls: ['./virtual-pcons-dialog.component.scss']
})
export class VirtualPconsDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<VirtualPconsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  onApply = new EventEmitter();
  onCancel = new EventEmitter();

  ngOnInit(): void {
  }

  cancel(): void {
    this.dialogRef.close();
    this.onCancel.emit();
  }

  submit(): void {
    this.onApply.emit(this.data);
  }
}
